module.exports = __webpack_public_path__ + "images/155_160.jpg";